import { fg } from '@atlassian/jira-feature-gating';

export const isProjectFieldRemoved = () => {
	return (
		// eslint-disable-next-line jira/ff/no-preconditioning
		fg('remove-issueviewinteractivequery-m1') && fg('remove-issueviewinteractivequery-m3')
	);
};

const createProjectFragment = () => `
    project(projectKey: $projectKey) {
        ${!fg('remove-issueviewinteractivequery-m1') ? 'id' : ''}
        ${fg('remove-issueviewinteractivequery-m1') ? '' : 'newIssueViewLockedIn'}
        ${
					!fg('remove-issueviewinteractivequery-m3')
						? `issueTypes {
                                id
                                name
                                iconUrl
                                subtask
                            }`
						: ''
				}
        
    }
`;

export default createProjectFragment;
